import { Search as SearchIcon } from '@mui/icons-material'
import { Box, InputAdornment, TextField, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface SettingsSearchbarProps {
  searchQuery: string
  onSearchChange: (value: string) => void
}

export const SettingsSearchbar = ({ searchQuery, onSearchChange }: SettingsSearchbarProps) => {
  const theme = useTheme()
  const { t } = useTranslation('settings')

  return (
    <Box sx={{ p: 3 }}>
      <TextField
        fullWidth
        placeholder={t('search-placeholder')}
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: 'neutralLight.900', width: 18, height: 18 }} />
            </InputAdornment>
          ),
        }}
        sx={(theme) => ({
          '& .MuiOutlinedInput-root': {
            height: '32px',
            backgroundColor: 'transparent',
            '& fieldset': {
              borderColor: theme.palette.divider,
              borderWidth: '1px',
              borderRadius: 2.5,
            },
            '&:hover fieldset': {
              borderColor: theme.palette.text.disabled,
            },
            '&.Mui-focused fieldset': {
              borderColor: theme.palette.text.disabled,
            },
            paddingLeft: '12px',
          },
          '& .MuiInputBase-input': {
            padding: '5.5px 10px 5.5px 0',
            fontSize: 12,
            color: theme.palette.text.secondary,
            height: '32px',
          },
          '& .MuiInputBase-input::placeholder': {
            color: theme.palette.text.disabled,
            opacity: 1,
            fontSize: 12,
          },
        })}
      />
    </Box>
  )
}
